<template>
  <div class="container">
    <div class="oil g-flex-center-start">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="选择油站:">
          <el-select  size="small" v-model="form.gasId" placeholder="选择油站" @change="handleChangeOil">
            <el-option v-for="item in gasOpitions" :key="item.gasId" :label="item.gasName" :value="item.gasId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select  size="small" v-model="timeType" placeholder="选择日期" @change="handleChangeTimeType">
            <el-option v-for="item in selectTime" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="[2, 3].includes(timeType)">
          <el-date-picker value-format="yyyy-MM-dd" :disabled="disabledTime" size="small"  v-model="form.valueRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item v-else>
          <el-date-picker key="position" value-format="yyyy-MM-dd" size="small" :picker-options="pickerOptions" :clearable="false" v-model="form.valueSingle" @change="haddleChangeSingle" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="cash g-flex-sb">
      <tabs :styleObj="styleObj" :title="'总销售额(元)'" :tabType="tabType" :cash="tabData.saleAmount" :num="tabData.saleAmountCompare"/>
      <tabs :styleObj="styleObj" :title="'加油升数(L)'"  :tabType="tabType" :cash="tabData.saleLiter" :num="tabData.saleLiterCompare"/>
      <tabs :styleObj="styleObj" :title="'订单数量(笔)'" :tabType="tabType" :cash="tabData.orderQuantity" :num="tabData.orderQuantityCompare"/>
      <tabs :styleObj="styleObj" :title="'客单价(元)'"   :tabType="tabType" :cash="tabData.customerUnitPrice" :num="tabData.customerUnitPriceCompare"/>
    </div>
    <div class="analyse g-flex-sb">
      <div class="user">
        <div class="analyse-title">用户分析</div>
        <userData :userData="userData"/>
      </div>
      <div class="oil-sale">
        <div class="analyse-title">油品销量金额占比</div>
        <div class="cake g-flex-sb">
          <div class="cake-pic">
            <pie :id="'oilChart'" :data="piePic"/>
          </div>
          <div class="cake-data">
            <div class="g-flex-c"><i class="color none"></i><span>油号</span><span>百分比</span><span>销售额</span></div>
            <ul class="oil-ul">
              <li class="g-flex-c" v-for="(item, index) in dataPie" :key="index">
                <span class="oil-name">{{item.oilNumberName}}</span><span>{{(item.amountPercentage * 100).toFixed(2)}}%</span><span>￥{{item.saleAmount | capitalize}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="order">
      <orderEchart :id="'orderChart'" :data="saleTrend" :abscissaLine="abscissaLine"/>
    </div>
    <div class="business">
      <div class="change-time g-flex-sb">
        <span @click="handleChangeCard(item)" :class="[isActiveType === item.activeType ? 'selected' : '' ]" v-for="item in bussinessList" :key="item.activeType">{{item.name}}</span>
      </div>
      <histogramEcharts :id="'business'" :data="ordinateHis" :abscissaHis="abscissaHis"/>
    </div>
  </div>
</template>
<script>
import tabs from './components/tabs'
import userData from './components/userData'
import pie from './components/pieEchart'
import orderEchart from './components/lineEchart'
import histogramEcharts from './components/histogramEcharts'
import { saleData, getuserData, turnoverStatistics, orderVolumeStatistics } from '@/api/dataCenter'
import { getAllGasInfoList } from '@/api/gasStationManage/gasInfo'
import moment from 'moment'

// 埋点
let mdObj = {
  pageview: {
    type: 'pageViewEvent',
    name: '数据中心',
    id: '1621476593'
  },
  changeStation: {
    type: 'clickEvent',
    name: '数据中心选择油站',
    id: '1621476595'
  },
  changeTime: {
    type: 'clickEvent',
    name: '数据中心选择日期',
    id: '1621476596'
  },
  changeYye: {
    type: 'clickEvent',
    name: '数据中心营业额选择统计',
    id: '1621476597'
  },
}
export default {
  data () {
    return {
     pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24
        }
      },
      // 表单
      form: {
        gasId: '',
        valueRange: [],
        valueSingle:''
      },
      timeType: 1, // 日期类型选择值
      gasOpitions: [], // 油站枚举
      selectTime: [{ code: 1, name: '选择日期' }, { code: 2, name: '过去7天' }, { code: 3, name: '过去30天' }],  // 选择日期类型枚举
      styleObj: { width: '24%', height: '150px' }, // tab-样式参数
      tabType: 1, // tab-展示类型
      tabData: {}, // tab-数据
      userData: {}, // 用户分析
      dataPie: [],  // 油品销量占比
      piePic: [], // 油品饼状图
      saleTrend: [], // 订单量时段分布-纵坐标
      abscissaLine: [], // 订单量时段分布-横坐标
      isActiveType: 0, // 营业额统计图-按日0按月1
      abscissaHis: [], // 营业额统计图-横坐标
      ordinateHis: [], // 营业额统计图-纵坐标
      bussinessList: [{ name: '按日', activeType: 0 }, { name: '按月', activeType: 1 }], // 营业额统计图-按日，按月切换
      disabledTime: false  // 7天和30天时间类型 不可选择
    }
  },
  components: {
    tabs,
    userData,
    pie,
    orderEchart,
    histogramEcharts
  },
  mounted () {
    this.form.valueSingle =  moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
    this.getAllGasStations()
    this.maidian(mdObj.pageview)
  },
  filters: {
		capitalize: function (val) {
			return (+val || 0).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
		}
	},
  methods: {
    maidian (obj) {
      const { type, name, id, other = {} } = obj
      this.$track[type](name, id, other)
    },
    // 切换油站
    handleChangeOil (val) {
      this.turnoverStatisticsApi({ gasId: val, period: 0 })
      this.maidian(mdObj.changeStation)
      this.isActiveType = 0 // 切换成按日
      switch (this.timeType) {
        case 1:
          {
            const params = { gasId: val, startDate: this.form.valueSingle, endDate: this.form.valueSingle }
            this.initThreeApi(params)
          }
          break
        case 2:
        case 3:
          {
            const params = { gasId: val, startDate: this.form.valueRange[0], endDate: this.form.valueRange[1] }
            this.initThreeApi(params)
          }
          break
      }
    },
    // 切换日期类型
    handleChangeTimeType (val) {
      const start = moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
      const Seven = moment(new Date()).subtract(7, "days").format("YYYY-MM-DD")
      const Thiyty = moment(new Date()).subtract(30, "days").format("YYYY-MM-DD")
      console.log(start,Seven)
      let other = {
        tysj_date_type: val,
        tysj_end_time: start
      }
      switch(val){
        case 1:
          {
            this.form.valueSingle =  start
            this.tabType = val
            const params = { gasId: this.form.gasId, startDate:start, endDate: start }
            this.initThreeApi(params)
            other.tysj_start_time = start

          }
          break
        case 2:
          {
            this.form.valueRange = [Seven, start]
            this.tabType = val
            this.disabledTime = true
            const params = { gasId: this.form.gasId, startDate:Seven, endDate: start }
            this.initThreeApi(params)
            other.tysj_start_time = Seven
          }
          break
        case 3:
          {
            this.form.valueRange = [Thiyty, start]
            this.tabType = val
            this.disabledTime = true
            const params = { gasId: this.form.gasId, startDate:Thiyty, endDate: start }
            this.initThreeApi(params)
            other.tysj_start_time = Thiyty
          }
          break
      }
      mdObj.changeTime.other = other
      this.maidian(mdObj.changeTime)
    },
    // 切换单个日期
    haddleChangeSingle (val) {
      let time = moment(val).format("YYYY-MM-DD")
      const params = { gasId: this.form.gasId, startDate: time, endDate: time }
      let other = {
        tysj_start_time: time,
        tysj_end_time: time
      }
      mdObj.changeTime.other = other
      this.maidian(mdObj.changeTime)
      this.initThreeApi(params)
    },
    // 调取三个接口
    initThreeApi (params) {
      params.source = 'pc'
      this.saleDataApi(params)
      this.getuserDataApi(params)
      this.orderVolumeStatisticsApi(params)
    },
    // 切换营业额按日还是按月
    handleChangeCard ({ activeType }) {
      let other = { tysj_date_type: activeType + 1 }
      mdObj.changeYye.other = other
      this.maidian(mdObj.changeYye)
      this.isActiveType = activeType
      this.turnoverStatisticsApi({ gasId: this.form.gasId, period: activeType })
    },
    // 获取销售数据
    async saleDataApi (params) {
      try {
        const { code, result } = await saleData(params)
        if (code !== 200) return
        this.tabData = result
        this.dataPie = result.oilNumberSale
        const pic = []
        result.oilNumberSale.forEach(item => {
          pic.push({
            value: item.saleAmount,
            name: item.oilNumberName
          })
        })
        this.piePic = pic
      } catch (error) {
        console.log(error)
      }
    },
    // 获取折线图
    async orderVolumeStatisticsApi (params) {
      try {
        const { code, result } = await orderVolumeStatistics(params)
        if (code !== 200) return
        const abscissa = []
        const saleValue = []
        result.forEach(item => {
          abscissa.push(item.abscissa)
          saleValue.push({ value: item.turnover, pay: item.orderNum })
        })
        this.saleTrend = saleValue
        this.abscissaLine = abscissa
      } catch (error) {
        console.log(error)
      }
    },
    // 获取用户占比销售数据
    async getuserDataApi (params) {
      try {
        const { code, result } = await getuserData(params)
        if (code !== 200) return
        this.userData = result
      } catch (error) {
        console.log(error)
      }
    },
    // 营业额统计图
    async turnoverStatisticsApi (params) {
      try {
        const { code, result } = await turnoverStatistics(params)
        if(code !== 200) return
        const abscissaHis = []
        const ordinateHis= []
        result.forEach(item => {
          abscissaHis.push(item.abscissa)
          ordinateHis.push(item.turnover)
        });
        this.abscissaHis = abscissaHis
        this.ordinateHis = ordinateHis
      } catch (error) {
        console.log(error)
      }
    },
    //获取油站
    async getAllGasStations () {
      try{
        const { code, result = [] } = await getAllGasInfoList()
        if(code !== 200) return
        this.gasOpitions = result
        this.form.gasId = result[0].gasId
        // 接口集合
        const params = { gasId: this.form.gasId, startDate: this.form.valueSingle, endDate: this.form.valueSingle }
        this.initThreeApi(params)
        // 柱状图接口
        this.turnoverStatisticsApi({ gasId: this.form.gasId, period: 0 })
      }catch(e){
        console.log(e)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.container{
  width: 100%;
  margin: 25px 0;
}
.oil{
  width: 100%;
  height: 100px;
  padding-left: 20px;
  background: #fff;
}
.cash{
  margin-top: 20px;
}
.analyse{
  width: 100%;
  >div{
    width: 49.3%;
    height: 320px;
    margin-top: 20px;
    background: #fff;
  }
  .analyse-title{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
  }
  .user{
    padding: 20px 10px 10px 10px;
  }
  .oil-sale{
    padding: 20px 10px 10px 10px;
    .cake-pic{
      width: 49%;
      height: 280px;
    }
    .cake-data {
      width: 49%;
      height: 280px;
      >div, li{
        width: 100%;
        >span{
          display: block;
          width: 33.33%;
          height: 30px;
          text-align: left;
          line-height: 30px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
        }
        .color{
          display: inline-block;
          width: 8px;
          height: 8px;
          margin-right: 10px;
          border-radius: 50%;
          background: skyblue;
        }
        .none{
          opacity: 0;
        }
      }
      .oil-ul{
        margin: 0;
        padding: 0;
        height: 240px;
        overflow-y: auto;
      }
    }
  }
}
.order, .business{
  width: 100%;
  height: 465px;
  padding: 20px;
  margin-top: 20px;
  background: #fff;
}
.business{
  position: relative;
  margin-top: 20px;
  .change-time{
    width: 80px;
    height: 40px;
    position: absolute;
    top: 20px;
    right: 80px;
    z-index: 10;
    >span{
      display: inline-block;
      height: 30px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      // border-bottom: 2px solid #4B7EFE;
    }
    .selected{
      color: #4B7EFE;
      border-bottom: 2px solid #4B7EFE;
    }
  }
}
</style>